import { render, staticRenderFns } from "./ClickableTextBox.vue?vue&type=template&id=2207085c&"
import script from "./ClickableTextBox.vue?vue&type=script&lang=js&"
export * from "./ClickableTextBox.vue?vue&type=script&lang=js&"
import style0 from "./ClickableTextBox.vue?vue&type=style&index=0&id=2207085c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports